import { render } from "./Kefu.vue?vue&type=template&id=1bae81df"
import script from "./Kefu.vue?vue&type=script&lang=js"
export * from "./Kefu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__